import { useContext, useState } from 'react';
import { ActionIcon, Button, Group, Loader, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconCheck, IconArrowBackUp, IconX } from '@tabler/icons';
import AppContext from '../AppContext';
import { AlertNotification } from '../AlertNotification';

interface PropsInterface {
    label: string,
    api: string,
    params: string,
    handle: any,
}

const RestoreButton = ({label, api, params, handle}: PropsInterface) => {

    const myContext = useContext(AppContext);
    const [isOpened, setIsOpened] = useState(false);
    const [isRestoring, setIsRestoring] = useState(false);
    const [word, setWord] = useState('');
    
    const restore = () => {
        setIsRestoring(true);
        myContext.httpClient.get(`${myContext.apiAddress}/${api}?${params}`).then((res:any) => {
            setIsRestoring(false);
            setIsOpened(false);
            if (res.data.status === true) {
                handle(); // La suite est traitée par le composant parent.
            } else {
                AlertNotification({message: (res.data.message || `Error in ${label}`)});
            }
        });
    }

    return  (
        <>
        <Modal
            opened={isOpened}
            onClose={() => { setIsOpened(false)}}
            title={label}
        >
            {isRestoring && <Group position="center" align="center">
                <Loader/>
                <Text>Restauration en cours...</Text>
            </Group>}
            {!isRestoring && <Stack>
                <Text>
                    Afin de confirmer la restauration, merci de saisir le mot RESTORE ci-après, puis de valider.
                </Text>
                <TextInput
                    value={word}
                    onChange={(event) => setWord(event.target.value.trim())}
                    error={word !== 'RESTORE'}
                />
                <Group position="apart">
                    <Button leftIcon={<IconX/>} color="blue" onClick={() => setIsOpened(false)}>
                        annuler
                    </Button>
                    <Button leftIcon={<IconCheck/>} color="blue" onClick={() => restore()}
                        disabled={word !== 'RESTORE'}
                    >
                        restaurer
                    </Button>
                </Group>
            </Stack>}
        </Modal>
        <ActionIcon variant="outline" color="blue" 
            onClick={() => { setIsOpened(true); setWord('');}}
        >
            <IconArrowBackUp size={16}/>
        </ActionIcon>
        </>
    )
}

export { RestoreButton }